import gql from 'graphql-tag';

import dokkioUserFragment from '../fragments/dokkioUserFragment';

export const mutationUpdateDokkioUser = gql`
  mutation updateDokkioUser (
    $id: DokkioID
    $primaryFirstName: String
    $primaryLastName: String
    $primaryEmail: String
    $primaryImageURL: String
    $dokkioGroupSlug: DokkioUserDokkioGroupSlug
    $role: DokkioUserRole
    $summary: String
    $onboardingState: DokkioUserOnboardingState
    $suggestionsPopUpViewedAt: DateTime
    $suggestedTopicsPopUpViewedAt: DateTime
    $filteringPopUpViewedAt: DateTime
    $listSettingsPopUpViewedAt: DateTime
    $blogNotificationsViewedAt: DateTime
    $lastModifiedNotificationsViewedAt: DateTime
    $desktopAppInitialIntegrationsSetupAt: DateTime
    $desktopAppDownloadBannerDismissedAt: DateTime
    $sidebarInstallBannerDismissedAt: DateTime
    $credentialScopeUpgradeBannerDismissedAt: DateTime
    $verificationHash: String
    $createWebpageEnabled: Boolean
    $activeReferralDismissedAt: DateTime
    $showIntegrationThreads: Boolean
    $timeZone: String
    $phoneNumber: String
    $smsOptedIn: Boolean
  ) {
    updateDokkioUser (
      id: $id
      primaryFirstName: $primaryFirstName
      primaryLastName: $primaryLastName
      primaryEmail: $primaryEmail
      primaryImageURL: $primaryImageURL
      dokkioGroupSlug: $dokkioGroupSlug
      role: $role
      summary: $summary
      onboardingState: $onboardingState
      suggestionsPopUpViewedAt: $suggestionsPopUpViewedAt
      suggestedTopicsPopUpViewedAt: $suggestedTopicsPopUpViewedAt
      filteringPopUpViewedAt: $filteringPopUpViewedAt
      listSettingsPopUpViewedAt: $listSettingsPopUpViewedAt
      blogNotificationsViewedAt: $blogNotificationsViewedAt
      lastModifiedNotificationsViewedAt: $lastModifiedNotificationsViewedAt
      desktopAppInitialIntegrationsSetupAt: $desktopAppInitialIntegrationsSetupAt
      desktopAppDownloadBannerDismissedAt: $desktopAppDownloadBannerDismissedAt
      sidebarInstallBannerDismissedAt: $sidebarInstallBannerDismissedAt
      credentialScopeUpgradeBannerDismissedAt: $credentialScopeUpgradeBannerDismissedAt
      verificationHash: $verificationHash
      createWebpageEnabled: $createWebpageEnabled
      activeReferralDismissedAt: $activeReferralDismissedAt
      showIntegrationThreads: $showIntegrationThreads
      timeZone: $timeZone
      phoneNumber: $phoneNumber
      smsOptedIn: $smsOptedIn
    ) {
      ...dokkioUserFragment
    }
  }
  ${dokkioUserFragment}
`;
export default mutationUpdateDokkioUser;
